import { cn } from '@/utils/cn'
import { type VariantProps, cva } from 'class-variance-authority'
import { type IconProps, iconVariants } from './common'

const arrowsInwardsOutwardsIconVariants = cva('', {
  variants: {
    inwards: {
      true: cn('[&_[data-arrow-left]]:translate-x-[145%]', '[&_[data-arrow-right]]:-translate-x-[145%]'),
      false: '',
    },
  },
})

export const ArrowsInwardsOutwardsIcon = ({
  className,
  size = 20,
  inwards,
  ...props
}: IconProps & VariantProps<typeof arrowsInwardsOutwardsIconVariants>) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size }), arrowsInwardsOutwardsIconVariants({ inwards }), className)}
      {...props}
    >
      <g className="origin-center transition-transform [transform-box:fill-box]" data-arrow-left>
        <path
          d="M5.46967 11.4697C5.32902 11.6103 5.25 11.8011 5.25 12C5.25 12.1989 5.32902 12.3897 5.46967 12.5303L9.46967 16.5303C9.76257 16.8232 10.2374 16.8232 10.5303 16.5303C10.8232 16.2374 10.8232 15.7626 10.5303 15.4697L7.06066 12L10.5303 8.53033C10.8232 8.23744 10.8232 7.76256 10.5303 7.46967C10.2374 7.17678 9.76256 7.17678 9.46967 7.46967L5.46967 11.4697Z"
          fill="currentColor"
        />
      </g>

      <g className="origin-center transition-transform [transform-box:fill-box]" data-arrow-right>
        <path
          d="M13.4697 15.4697C13.1769 15.7626 13.1769 16.2374 13.4697 16.5303C13.7626 16.8232 14.2375 16.8232 14.5304 16.5303L18.5304 12.5303C18.6711 12.3897 18.7501 12.1989 18.7501 12C18.7501 11.8011 18.6711 11.6103 18.5304 11.4697L14.5304 7.46967C14.2375 7.17678 13.7626 7.17678 13.4697 7.46967C13.1769 7.76256 13.1769 8.23744 13.4697 8.53033L16.9394 12L13.4697 15.4697Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
